import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { ResetCurrentFilter } from '../state/main-table-filter.actions';

export const paginationInitResolver: ResolveFn<void> = () => {
  const store = inject(Store);
  store.dispatch(new ResetCurrentFilter());
};
